export const LISTED_CONTACTS = "SET_LISTED_CONTACTS";

export const setListedContacts = (listedContacts) => {
	return {
		type: LISTED_CONTACTS,
		listedContacts,
	};
};
